import RESOURCE from '~/modules/resources/types';
import create from '~/misc/create';
import resourceId from '~/misc/resourceId';

const preload = ({dispatch}) => {
  dispatch(create(RESOURCE.RESOURCE_NEEDED, {
    name: 'brokers-search-data',
    need: resourceId('brokers-search-data', {}),
    needy: {key: 'main-search-form'},
  }));
};

export default preload;



// WEBPACK FOOTER //
// ./src/modules/brokers/preload.js